import { handleSessionError } from './ErrorHandler'

let tokenExpirationTimeout: ReturnType<typeof setTimeout> | null = null
let tokenExpirationTimeoutExpiry: number | null = null

// Check if the token is expired using the exp claim
export const isTokenExpiredFromExp = (exp: number): boolean => {
  const currentTime = Math.floor(Date.now() / 1000) // Current time in seconds
  return currentTime >= exp // Token is expired if current time >= exp
}

// Schedule a reauthentication 7 hours after the token expires using the exp claim
export const scheduleExpirationCheckFromExp = (exp: number) => {
  const currentTime = Date.now() // Current time in milliseconds
  const expirationTime = exp * 1000 // Convert seconds to milliseconds

  // Add 8 hours (7 * 60 * 60 * 1000 ms) and one minute (+ 60 * 1000) to the expiration time
  const extendedExpirationTime = expirationTime + 7 * 60 * 60 * 1000 + 60 * 1000
  const timeUntilExpiry = extendedExpirationTime - currentTime

  if (timeUntilExpiry <= 0) {
    console.warn('Token expiration has already passed.')
    handleSessionError(
      'Your session has expired. Please refresh the page. If issue persist, try loging out and back in again.',
      true,
      0,
      'Refresh',
      true
    )
    return
  }

  if (tokenExpirationTimeout && tokenExpirationTimeoutExpiry === extendedExpirationTime) {
    return // No need to recreate the timeout
  }

  // Clear any existing timeout using the helper function
  clearTokenExpirationCheck()

  // Schedule reauthentication
  tokenExpirationTimeout = setTimeout(() => {
    handleSessionError('Your session has expired. Please refresh the page.')
  }, timeUntilExpiry)

  // Store the new expiration time
  tokenExpirationTimeoutExpiry = extendedExpirationTime
}

// Clear token expiration timeout
export const clearTokenExpirationCheck = () => {
  if (tokenExpirationTimeout) {
    clearTimeout(tokenExpirationTimeout)
    tokenExpirationTimeout = null
    tokenExpirationTimeoutExpiry = null
  }
}
